import React, { Component } from 'react'
import ReactTable from "react-table"
import { connect } from 'react-redux'
import settings from '../../../settings'
import axios from 'axios'
import { Grid, Row, Col } from 'react-bootstrap'
// import { fetchCollection, fetchDataAnalytics } from '../../common/redux/collectionActions'
import dayjs from 'dayjs'
import LockQueryPopover from './LockQueryPopover'

class LockWatch extends Component {
    constructor(p) {
        super(p)
    }

    state = { popoverTarget: null }

    componentDidMount() {
        // axios.get(`${window.MYQLOCX_API}/subject/admin/bi/settings/querywatch`).then(t => {
        //     const data = t.data
        //     // this.setState({ data }, () => console.log(this.state.data))
        // }).catch(function (e) {
        //     console.log(e)
        // })
    }

    createReport = () => {
        fetch(`${window.MYQLOCX_API}/subject/admin/bi/generatereport/${this.props.lock._id}`, {
            method: 'put',
            headers: axios.defaults.headers.common
        }).then(t => t.json()).then(t => {
            console.log(t)
        })
    }

    render() {
        const colSize = 2
        const { lock, watch = {} } = this.props

        console.log(lock, watch)

        return (
            <Row style={{ padding: 15 }}>
                <div style={{ border: '1px solid #006e78', borderRadius: 10, width: '100%', padding: 20 }}>
                    <Col sm={6} md={6} lg={6}>
                        {lock.custom_name}<br />{lock.address.street}
                    </Col>
                    <Col sm={colSize} md={colSize} lg={colSize}>
                        <LockQueryPopover queries={watch.queries ? watch.queries.values : []} generateReportIntervalMinutes={watch.generateReportIntervalMinutes !== undefined ? watch.generateReportIntervalMinutes : 360} lockId={lock._id} />
                    </Col>
                    <Col sm={colSize} md={colSize} lg={colSize}>

                    </Col>
                    <Col sm={colSize} md={colSize} lg={colSize}>
                        <button onClick={this.createReport}>Skapa rapport nu</button>
                    </Col>
                </div>
            </Row>
        )
    }

}


const mapProps = state => {
    return {
    }
}

const mapDispatch = dispatch => {
    return {
    }
}

export default connect(mapProps, mapDispatch)(LockWatch)
